<template>
  <v-dialog
    persistent
    no-click-animation
    fullscreen
    v-model="showDialog"
    transition="dialog-bottom-transition"
  >
    <v-card class="detail" max-width="768" tile v-if="payment">
      <v-card-title class="justify-end px-3 py-2">
        <a @click="closeDialog()" id="btn__i95umKRagEGFE3WhdmEmGA==">
          <v-icon large> mdi-close </v-icon>
        </a>
      </v-card-title>
      <v-card-text class="text-center px-4">
        <v-row cols="12" class="mt-2" no-gutters>
          <v-col cols="12">
            <p class="mb-5 font--m-3">송금 상세</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <table class="pa-3">
          <tr>
            <td class="font--m-4 color--buynow">요청 날짜</td>
            <td class="payment font--m-5">{{ payment.date }}</td>
          </tr>
          <tr>
            <td class="font--m-4 color--buynow">거래처 명</td>
            <td class="payment font--m-5">{{ payment.wholesalerAccount.wholesaler.name }}</td>
          </tr>
          <tr>
            <td class="font--m-4 color--buynow">주소</td>
            <td class="payment font--m-5">{{ payment.wholesalerAccount.wholesaler.location }}</td>
          </tr>
          <tr>
            <td class="font--m-4 color--buynow">신청 금액</td>
            <td class="payment font--m-5">{{ payment.amount | commaFormat }}원</td>
          </tr>
          <tr>
            <td class="font--m-4 color--buynow">송금처</td>
            <td class="payment font--m-5">
              {{ payment.wholesalerAccount.bank | bankCodeName }}
              {{ payment.wholesalerAccount.number }} <br />
              {{ payment.wholesalerAccount.holderName }}
            </td>
          </tr>
          <tr>
            <td class="font--m-4 color--buynow">현재 상태</td>
            <td
              class="payment font--m-5"
              :key="refreshTime"
              :class="{
                'color--pinkred-110': payment.status !== 'completed',
                'color--green': payment.status === 'completed',
              }"
            >
              {{ payment.status | choiceName('payment-status') }}
            </td>
          </tr>
          <tr>
            <td class="font--m-4 color--buynow">완료 시각</td>
            <td class="payment font--m-5">
              {{ payment.completedAt | moment('YYYY-MM-DD HH:mm:ss') }}
            </td>
          </tr>
          <tr>
            <td class="font--m-4 color--buynow">입금자명</td>
            <td class="payment font--m-5">
              {{ payment.depositName }}
            </td>
          </tr>
        </table>
      </v-card-text>
      <div v-if="mode === 'local'">
        {{ payment }}
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      showDialog: true,
      inputPw: null,
      confirmPw: '0000',
      payment: null,
    }
  },
  async created() {
    this.getPayment()
  },
  computed: {
    ...mapState('choice', ['refreshTime']),
    ...mapState('env', ['mode']),
    validPw() {
      return this.inputPw === this.confirmPw
    },
  },
  methods: {
    ...mapActions('bnpl', ['getPaymentsDetail']),
    async closeDialog() {
      this.$emit('emitShow', false)
    },
    async getPayment() {
      this.payment = await this.getPaymentsDetail(this.$route.params.uuid)
    },
  },
}
</script>
<style lang="scss" scoped>
.detail {
  table {
    border: 1px solid;
    width: 100%;
    tr {
      td {
        width: 30%;
        padding-bottom: 4px;
      }

      .payment {
        width: 70%;
        text-align: right;
      }
    }
  }
}
</style>
